import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Michael Irigoyen
 * id 815B35DE-0C4D-46AD-90EC-2AFEE0A5FC17
 * name star-three-points
 * version: 2.7.94
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/star-three-points.svg
 * tags
 * - Shape 
 */
export const StarThreePointsIcon = createSvgIcon(<><path d="M12,2.6L9,12.4L2,19.9L12,17.6L22,20L15,12.5L12,2.6Z" /></>, 'StarThreePointsIcon');
export default StarThreePointsIcon